import { useState } from 'react';
import { PaperPlaneRight } from '@phosphor-icons/react';

import { Spinner } from '@/components/ui';
import { sanitizeString } from '@/lib/sanitize';

import styles from './CommentInput.module.css';

interface CommentInputProps {
    onSubmit: (text: string) => void;
    placeholder?: string;
    isLoading?: boolean;
    autoFocus?: boolean;
}

export function CommentInput({
    onSubmit,
    placeholder = 'Escribe un comentario...',
    isLoading = false,
    autoFocus = false,
}: CommentInputProps) {
    const [text, setText] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const trimmed = sanitizeString(text);
        if (!trimmed || isLoading) return;
        onSubmit(trimmed);
        setText('');
    };

    return (
        <form className={styles.form} onSubmit={handleSubmit}>
            <input
                className={styles.input}
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder={placeholder}
                disabled={isLoading}
                autoFocus={autoFocus}
                maxLength={2000}
            />
            <button
                className={`${styles.submit} ${isLoading ? styles.submitLoading : ''}`}
                type="submit"
                disabled={!text.trim() || isLoading}
                aria-label="Enviar comentario"
            >
                {isLoading ? (
                    <Spinner size="xs" variant="secondary" />
                ) : (
                    <PaperPlaneRight size={18} weight="fill" />
                )}
            </button>
        </form>
    );
}
